import { DropdownList as BaseDropdownList } from 'qampo-ui-library/base';
import type { DropdownListProps as BaseDropdownListProps } from 'qampo-ui-library/base';

// Design-token styling applied to every DropdownList so callers don't repeat it.
const TRIGGER_STYLES: React.CSSProperties = {
  background: 'var(--color-surface-primary)',
  border: '1px solid var(--color-border-primary)',
  borderRadius: 'var(--radius-regular)'
};

// The panel grows to fit the widest option but never narrows below the trigger.
// Callers pass `panelMaxWidth` to cap that growth at their container's width.
const PANEL_STYLES: React.CSSProperties = {
  width: 'max-content',
  minWidth: '100%',
  background: 'var(--color-surface-primary)',
  borderRadius: 'var(--radius-regular)'
};

interface DropdownListProps<T> extends BaseDropdownListProps<T> {
  /** Caps panel growth at this pixel width (e.g. the surrounding container). */
  panelMaxWidth?: number;
}

export const DropdownList = <T,>({ panelMaxWidth, styles, ...rest }: DropdownListProps<T>) => (
  <BaseDropdownList<T>
    {...rest}
    styles={{
      ...styles,
      trigger: { ...TRIGGER_STYLES, ...styles?.trigger },
      panel: { ...PANEL_STYLES, maxWidth: panelMaxWidth, ...styles?.panel }
    }}
  />
);
